import { IPhoneNumber } from '../../data-access/interfaces';

export function formatTelephoneNumber(phoneNumber: IPhoneNumber): string {
  return `(+${phoneNumber.countryCode}) ${phoneNumber.phoneNumber}`;
}
